export default __webpack_public_path__ + "static/media/DarkLogo.535540c5.png";